import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { ModalData } from './modal';
import type { Params } from '~/embed/types';
import type { Comment } from '~/types/comment';
import { activeComment } from './activeComment/initial-value';
import { comments } from './comments/initial-value';
import { embed } from './embed/initial-value';
import { modal } from './modal/initial-value';

export interface State {
  activeComment: string | null;
  comments: Record<string, Comment>;
  modal: ModalData | null;
  embed: {
    userId: string;
    clickId: string;
    appName: string;
    appVersion: string;
    channelDepth: number;
    contentWidth: number;
    isFullWidth: boolean;
    isOpen: boolean;
  } & Omit<Params, 'isFullWidth' | 'isOpen' | 'channelDepth' | 'contentWidth'>;
}

export const useStore = create<State>()(
  devtools(() => ({
    activeComment,
    comments,
    modal,
    embed,
  }))
);
